import React from 'react'
const MapContext = React.createContext()
export default MapContext
